import React, { useCallback, useEffect, useState } from "react";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { HeaderButton, Buttons } from "components";
import XGrid from "components/UI/Grid/XGrid";
import Modal from "components/UI/Modal/Modal";
import { useService } from "components/route/ServiceRoute";
import { hotelesTitles as titles } from "consts/titulos-de-tablas";
import { ACTIONS } from "consts/Actions";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { SFUsuarioHotelGet } from "services/services-mia/SFUsuarioHotelGet";
import { provinciaGet } from "services/services-mia/provinciaGet";
import { mapHotelList } from "pages/hoteles/utils/mapHotel";
import { UpdateModal, QrModal } from "./Actions";
import qrImg from "assets/icons/DescargarQR.svg";
import styles from "styles/pages/Pages.module.scss";

export default function HotelesList() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);
    const { service } = useService();

    const [loading, setLoading] = useState(false);
    const [hoteles, setHoteles] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const [modalDetails, setModalDetails] = useState({ isOpen: false });

    const getHoteles = useCallback(async () => {
        setHoteles([]);
        setLoading(true);
        const result = await SFUsuarioHotelGet(credentials);

        setHoteles(mapHotelList(result));
        setLoading(false);
    }, [credentials]);

    const closeModal = () => {
        setModalDetails((prev) => ({ ...prev, isOpen: false }))
        setTimeout(() => {
            setRowSelected({ status: false, row: {} });
        }, 100);
    };

    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    useEffect(() => {
        getHoteles();
    }, [getHoteles]);

    useEffect(() => {
        if (Object.keys(credentials).length === 0) return;

        (async () => {
            const { result: resultProvincias } = await provinciaGet(credentials);
            setProvincias(
                (resultProvincias ?? []).filter((r) => r.provinciaSantaFeId)
            );
        })();
    }, [credentials]);

    useEffect(() => {
        setRoute({
            wordKey: `Hoteles`,
        });
    }, [service?.servicioNombre, setRoute]);

    return (
        <main className={styles.main}>
            <Modal
                open={modalDetails.isOpen}
                title={modalDetails.title}
                onClose={closeModal}
            >
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        updateList={getHoteles}
                        closeModal={closeModal}
                        provincias={provincias}
                        hotel={rowSelected.row}
                    />
                )}
                {modalDetails.procede === ACTIONS.QR && (
                    <QrModal
                        hotel={rowSelected.row}
                        closeModal={closeModal}
                    />
                )}
            </Modal>

            <div className={styles["filters-actions-right"]}>
                <Buttons>
                    <HeaderButton text="Actualizar" onClick={getHoteles}>
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text="Editar hotel"
                        handleClick={handleClick}
                        data={{ title: "Editar hotel", procede: ACTIONS.UPDATE }}
                        disabled={
                            !rowSelected.row.id ||
                            rowSelected.row.SFHotelStatus === "B" ||
                            service?.servicioPermiso !== "E"
                        }
                    >
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text="Generar QR"
                        handleClick={handleClick}
                        data={{
                            title: `QR - ${rowSelected.row?.SFHotelNombre ?? "Hotel"}`,
                            procede: ACTIONS.QR,
                        }}
                        disabled={
                            !rowSelected.row.id ||
                            rowSelected.row.SFHotelStatus === "B"
                        }
                    >
                        <img src={qrImg} style={{ width: "24px" }} alt="qr" />
                    </HeaderButton>
                </Buttons>
            </div>

            <div className={styles.container}>
                <XGrid
                    rows={hoteles}
                    titles={titles}
                    loading={loading}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                    updateList={getHoteles}
                />
            </div>
        </main>
    );
}
